import { createAction } from 'redux-actions'

export const clearServicesAgreementDetails = createAction(
  'CLEAR_SERVICES_AGREEMENT_DETAILS'
)

export const clearBDplanAgreementDetails = createAction(
  'CLEAR_BD_PLAN_AGREEMENT_DETAILS'
)

export const setShouldTriggerAllServicesAgreementsFetch = createAction(
  'SET_SHOULD_TRIGGER_ALL_SERVICES_AGREEMENTS_FETCH'
)

export const setSearchShouldTriggerAllServicesAgreementsFetch = createAction(
  'SET_SEARCH_SHOULD_TRIGGER_ALL_SERVICES_AGREEMENTS_FETCH'
)

export const setShouldTriggerServicesAgreementDetailsFetch = createAction(
  'SET_SHOULD_TRIGGER_SERVICES_AGREEMENT_DETAILS_FETCH'
)

export const resetSearchOrderCost = createAction('RESET_SEARCH_ORDER_COST')

export const setShouldTriggerSearchesFetch = createAction(
  'SET_SHOULD_TRIGGER_SEARCHES_FETCH'
)
export const setShouldTriggerAllBDPlanAgreementsFetch = createAction(
  'SET_SHOULD_TRIGGER_ALL_BD_PLAN_AGREEMENTS_FETCH'
)
export const setBdPlanAgreementDetails = createAction(
  'SET_BD_PLAN_AGREEMENT_DETAILS'
)
export const setBDPlanAgrementDetailsId = createAction(
  'SET_BD_PLAN_AGREEMENT_DETAILS_ID'
)
export const setShouldTriggerAllNotificationsPlanAgreementsFetch = createAction(
  'SET_SHOULD_TRIGGER_ALL_NOTIFICATIONS_PLAN_AGREEMENTS_FETCH'
)
export const setShouldTriggerAllTaxableServicesAgreementsFetch = createAction(
  'SET_SHOULD_TRIGGER_ALL_TAXABLE_SERVICES_AGREEMENTS_FETCH'
)
